import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label, BaseChartDirective } from 'ng2-charts';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  banner1: Boolean = true;
  allGroups: Array<any> = [];
  selected: any;
  banner2: Boolean = true;
  communityShow: Boolean = false;
  collection = [];
  aLoading: Boolean = false;
  oLoading: Boolean = false;
  selectedMeasure: String = 'All';
  timeOrCost: String = 'Time';
  actvities: Array<any> = [];
  categories: Array<any> = [];
  selectedCategories: Array<any> = [];
  communityUsers: Array<any> = [];
  selectedCommunities: Array<any> = [];
  indexSelect: Array<any> = [];
  progressIndex = {
    data: [],
    labels: [],
    units: []
  }
  timeLogged = {
    data: [],
    labels: []
  }
  myGroup = this.apiservice.user.group;
  selectedCategory: any = {};
  url = this.apiservice.url + '/uploads/';
  goalsShow: Boolean = false;
  upcomingChallenge: Array<any> = [];
  user = this.apiservice.user;
  indexDates = {
    start: moment().subtract(365, 'days').toDate(),
    end: moment().toDate()
  }
  timeLoggedDates = {
    start: moment().subtract(365, 'days').toDate(),
    end: moment().toDate()
  }
  activityCard: Boolean = false;
  activityData: any = {};
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService,
    private renderer: Renderer2
  ) {
  }

  showPages = ['10', '20', '50', '100', '200']

  ngOnInit() {
    this.getGroups();
    this.loadAllData();
    this.loadIndexData({ id: this.user._id });
  }

  loadAllData() {
    this.apiservice.createActivityLogs(this.user._id, this.selectedCategories, this.communityUsers).subscribe((res: any) => {
      this.actvities = res.data;
    });
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id).subscribe((res: any) => {
        let cate = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        cate.sort(function (a, b) {
          return a.rank - b.rank;
        });
        this.categories = cate.map(cat => {
          return cat['category'];
        });
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id).subscribe((res: any) => {
        this.categories = res.data;
      });
    }


    this.apiservice.getUpcomingChallenges(this.user._id, this.selectedCategories, this.communityUsers).subscribe((res: any) => {
      this.upcomingChallenge = res.data.filter(data => data.challenge !== null)
    })
    let users = [this.user._id];
    if (this.communityUsers.length > 0) {
      users = this.communityUsers;
    }
    this.apiservice.getOutcomeByUserPost(users).subscribe((res: any) => {
      this.indexSelect = [];
      let uniqueArray = res.data.filter(function (item, pos) {
        let indi = res.data.findIndex(el => el.what == item.what && el.operation == item.operation);
        if (indi >= 0) {
          return indi == pos;
        }
        return false;
      })
      uniqueArray.forEach(what => {
        this.indexSelect.push({ what: what.what, operation: what.operation, id: this.user._id });
      });
    });
  }

  subsFromALLGroups() {
    let joinedGroups = this.allGroups.filter(item => {
      let index = item.subscribers.findIndex(data => data._id == this.apiservice.user._id);
      if (index >= 0) {
        return true;
      }
      return false;
    });
    let subs = [];
    joinedGroups.forEach(ele => {
      ele.subscribers.forEach(element => {
        subs.push(element._id);
      });
    });
    this.communityUsers = subs;
  }

  loadDataAgain(tab) {
    if (tab == 'c') {
      this.subsFromALLGroups();
    } else {
      this.communityUsers = [];
    }
    this.selectedCategories = [];
    this.selectedCommunities = [];
    this.indexDates = {
      start: moment().subtract(365, 'days').toDate(),
      end: moment().toDate()
    }
    this.timeLoggedDates = {
      start: moment().subtract(365, 'days').toDate(),
      end: moment().toDate()
    }
    this.getGroups();
    this.loadAllData();
    this.loadIndexData({ id: this.user._id });

  }

  getGroups(id = null) {
    this.apiservice.getAllGroups().subscribe((res: any) => {
      this.allGroups = res.data;
      if (id !== null) {
        this.aLoading = true;
        this.oLoading = true;
        let selected = this.allGroups.filter(data => data._id == id);
        let subs = selected[0].subscribers.map(s => s._id);
        this.apiservice.getGroupActivity({ id: subs }).subscribe((resAct: any) => {
          this.aLoading = false;
          this.selected['activities'] = resAct.data;
        });
        this.apiservice.getGroupOutcome({ id: subs }).subscribe((resOut: any) => {
          this.oLoading = false;
          this.selected['outcomes'] = resOut.data;
        });
        this.selected = selected[0];
      }
    });
  }

  checkSelectedCategory(id) {
    let d = this.selectedCategories.filter(el => el == id);
    if (d.length > 0) {
      return true;
    }
    return false;
  }

  checkSelectedGroup(id) {
    let d = this.selectedCommunities.filter(el => el == id);
    if (d.length > 0) {
      return true;
    }
    return false;
  }

  checkCat(event, catId) {
    if (event.target.checked) {
      this.selectedCategories.push(catId);
    } else {
      let index = this.selectedCategories.findIndex(el => el == catId);
      this.selectedCategories.splice(index, 1);
    }
    this.loadAllData();
    this.loadIndexData({ id: this.user._id });
  }

  checkGroup(event, catId) {
    if (event.target.checked) {
      this.selectedCommunities.push(catId);
    } else {
      let index = this.selectedCommunities.findIndex(el => el == catId);
      this.selectedCommunities.splice(index, 1);
    }
    if (this.selectedCommunities.length == 0) {
      this.subsFromALLGroups();
    } else {
      let subs = [];
      this.allGroups.forEach(ele => {
        let selected = this.selectedCommunities.filter(e => e == ele._id);
        if (selected.length > 0) {
          ele.subscribers.forEach(element => {
            subs.push(element._id);
          });
        }
      });
      this.communityUsers = subs;
    }
    this.loadAllData();
    this.loadIndexData({ id: this.user._id });
  }

  open(group) {
    this.aLoading = true;
    this.oLoading = true;
    if (this.selected && this.selected.activities) {
      this.selected.activities = [];
    }
    if (this.selected && this.selected.outcomes) {
      this.selected.outcomes = [];
    }
    this.selected = group;
    let subs = group.subscribers.map(s => s._id);
    this.apiservice.getGroupActivity({ id: subs }).subscribe((resAct: any) => {
      this.aLoading = false;
      this.selected['activities'] = resAct.data;
    });
    this.apiservice.getGroupOutcome({ id: subs }).subscribe((resOut: any) => {
      this.oLoading = false;
      this.selected['outcomes'] = resOut.data;
    });
    this.renderer.addClass(document.body, 'overlay');
    this.communityShow = this.communityShow ? false : true;
  }

  aWidth(count) {
    let total = 0;
    if (this.selected && this.selected.activities) {
      this.selected['activities'].forEach((ele) => {
        total += parseInt(ele.count);
      });
      let percent: any = (count / total) * 100;
      return parseInt(percent);
    }
    return 0;
  }


  oWidth(count) {
    let total = 0;
    if (this.selected && this.selected.outcomes) {
      this.selected['outcomes'].forEach((ele) => {
        total += parseInt(ele.count);
      });
      let percent: any = (count / total) * 100;
      return parseInt(percent);
    }
    return 0;
  }

  closeGroup() {
    this.communityShow = this.communityShow ? false : true;
    this.renderer.removeClass(document.body, 'overlay');
  }


  joinedOrNot(subscribers) {
    if (subscribers) {
      let index = subscribers.findIndex(data => data._id == this.apiservice.user._id);
      if (index >= 0) {
        return true;
      }
      return false;
    }
  }

  join(group_id) {
    let users = [];
    users.push(this.apiservice.user._id);
    this.myGroup.push(group_id);
    this.apiservice.assignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getGroups(group_id);
    });
  }

  unjoin(group_id) {
    let users = [];
    users.push(this.apiservice.user._id);
    let index = this.myGroup.findIndex(data => data == group_id);
    this.myGroup.splice(index, 1);
    this.apiservice.deAssignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getGroups(group_id);
    });
  }

  getTime(seconds) {
    let totalSeconds = seconds;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return hours + 'h ' + minutes + 'm ' + s + 's';
  }

  formatTime(time) {
    if (time) {
      return moment(time).format('MMM DD, YYYY');
    }
    return null;
  }

  closeActivityCard() {
    this.activityCard = false;
    this.renderer.removeClass(document.body, 'overlay');

  }

  openCategory(category) {
    this.selectedCategory = category;
    this.selectedCategory['logged'] = this.actvities.filter(data => data.category._id == this.selectedCategory._id);
    this.renderer.addClass(document.body, 'overlay');
    this.goalsShow = !this.goalsShow;
  }

  closeCategory() {
    this.renderer.removeClass(document.body, 'overlay');
    this.goalsShow = !this.goalsShow;
  }

  loadLoggedAgain(value) {
    this.timeOrCost = value;
    this.loadTimeLoggedData({ id: this.user._id });
  }

  timeLoggedDateChange(event) {
    this.timeLoggedDates = this.dateFilter(event, this.timeLoggedDates);
    this.loadTimeLoggedData({ id: this.user._id });
  }

  loadTimeLoggedData(data) {
    if (this.communityUsers.length > 0) {
      data['users'] = this.communityUsers;
    }
    data['endDate'] = this.timeLoggedDates.end;
    data['startDate'] = this.timeLoggedDates.start;
    data['categories'] = this.selectedCategories;
    if (this.selectedMeasure !== 'All' && this.selectedMeasure !== 'savings' && this.selectedMeasure !== 'impact') {
      data['what'] = this.selectedMeasure;
    }
    this.apiservice.getTimeChartData(data).subscribe((res: any) => {
      let data = [], labels = [];
      res.data = res.data.sort(function (left, right) {
        return moment.utc(left.startTime).diff(moment.utc(right.startTime))
      });
      res.data.forEach(elem => {
        let index = labels.findIndex(ei => ei == moment(elem.startTime).format('DD-MMM-YYYY'));
        if (index >= 0) {
          labels[index] = moment(elem.startTime).format('DD-MMM-YYYY');
          if (this.timeOrCost == 'Time') {
            let hours = (elem.timeLogged / 3600).toFixed(2);
            data[index] = parseFloat(data[index]) + parseFloat(hours);
          } else {
            data[index] = parseFloat(data[index]) + parseFloat(elem.cost);
          }
        } else {
          labels.push(moment(elem.startTime).format('DD-MMM-YYYY'));
          if (this.timeOrCost == 'Time') {
            let hours = (elem.timeLogged / 3600).toFixed(2);
            data.push(hours);
          } else {
            data.push(elem.cost);
          }
        }
      });
      this.timeLogged['data'] = data;
      this.timeLogged['labels'] = labels;
      this.lineChartData[0].data = this.timeLogged['data'];
      this.lineChartLabels = this.timeLogged['labels'];
      this.chart.chart.update();
    });
  }

  openActivity(activity) {
    this.goalsShow = false;
    this.activityCard = true;
    this.activityData = activity;
  }

  dateFilter(event, obj) {
    if (event.target.value == '7') {
      obj = {
        start: moment().subtract(7, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == '30') {
      obj = {
        start: moment().subtract(30, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == '365') {
      obj = {
        start: moment().subtract(365, 'days').toDate(),
        end: moment().toDate()
      }
    } else if (event.target.value == 'month') {
      obj = {
        start: moment().subtract(1, 'months').startOf('month').toDate(),
        end: moment().subtract(1, 'months').endOf('month').toDate()
      }
    } else if (event.target.value == 'week') {
      obj = {
        start: moment().subtract(1, 'weeks').startOf('week').toDate(),
        end: moment().subtract(1, 'weeks').endOf('week').toDate()
      }
    } else if (event.target.value == 'year') {
      obj = {
        start: moment().subtract(1, 'years').startOf('year').toDate(),
        end: moment().subtract(1, 'years').endOf('year').toDate()
      }
    } else {
      obj = {
        start: moment().subtract(365, 'days').toDate(),
        end: moment().toDate()
      }
    }
    return obj;
  }

  indexDateChange(event) {
    this.indexDates = this.dateFilter(event, this.indexDates);
    this.loadIndexData({ id: this.user._id });
  }

  loadIndexData(data) {
    if (this.communityUsers.length > 0) {
      data['users'] = this.communityUsers;
    }
    if (data.what) {
      this.selectedMeasure = data.what;
    } else if (data.field) {
      this.selectedMeasure = data.field;
    } else {
      this.selectedMeasure = 'All';
    }
    this.loadTimeLoggedData(data);
    data['categories'] = this.selectedCategories;
    data['endDate'] = this.indexDates.end;
    data['startDate'] = this.indexDates.start;
    this.apiservice.getPIndex(data).subscribe((res: any) => {
      let labels = [], allData = [];
      res.data = res.data.sort(function (left, right) {
        return moment.utc(left.startTime).diff(moment.utc(right.startTime))
      });
      res.data.forEach(elem => {
        let index = labels.findIndex(ei => ei == moment(elem.startTime).format('DD-MMM-YYYY'));
        if (index >= 0) {
          labels[index] = moment(elem.startTime).format('DD-MMM-YYYY');

          if (elem.outcome) {
            allData[index] = elem.outcome;
          } else if (elem.postoutcomes.length > 0) {
            allData[index] = elem.postoutcomes[elem.postoutcomes.length - 1];
          } else if (elem.preoutcomes.length > 0) {
            allData[index] = elem.preoutcomes[elem.preoutcomes.length - 1];
          }

          if(elem.postoutcomeValue) {
            allData[index].howmuch = elem.postoutcomeValue;
          } else if(elem.preoutcomeValue) {
            allData[index].howmuch = elem.preoutcomeValue;
          }
        } else {
          labels.push(moment(elem.startTime).format('DD-MMM-YYYY'));
          if (elem.outcome) {
            allData.push(elem.outcome);
          } else if (elem.postoutcomes.length > 0) {
            allData.push(elem.postoutcomes[elem.postoutcomes.length - 1]);
            
          } else if (elem.preoutcomes.length > 0) {
            allData.push(elem.preoutcomes[elem.preoutcomes.length - 1]);
          }

          if(elem.postoutcomeValue) {
            allData[allData.length-1].howmuch = elem.postoutcomeValue;
          } else if(elem.preoutcomeValue) {
            allData[allData.length-1].howmuch = elem.preoutcomeValue;
          }
        }
      });

      let obj = {};
      allData.forEach((el, index) => {
        if (obj[el.what + '(' +
          el.operation + ')']) {
          obj[el.what + '(' +
            el.operation + ')'] = obj[el.what + '(' +
            el.operation + ')'];
        } else {
          obj[el.what + '(' +
            el.operation + ')'] = { data: [], units: [] };
          obj[el.what + '(' +
            el.operation + ')']['data'] = allData.map(e => {
              if (e.what == el.what && e.operation == el.operation) {
                return parseInt(e.howmuch)
              }
              return 0;
            });
          obj[el.what + '(' +
            el.operation + ')']['units'] = allData.map(e => {
              if (e.what == el.what && e.operation == el.operation) {
                return e.what+' '+e.operation+' '+e.howmuch+' '+e.unit;
              }
              return null;
            });
        }
      });

      this.progressChartData = [];
      let array = [], units = [];
      Object.keys(obj).forEach(function (key) {
        array.push({
          data: obj[key]['data'],
          label: key,
          lineTension: 0,
          pointBackgroundColor: '#' + ('00000' + (Math.random() * (1 << 24) | 0).toString(16)).slice(-6),
          pointBorderWidth: 2,
          pointRadius: 5,
          pointBorderColor: '#fff',
        });
        units.push(obj[key]['units']);
      });
      this.progressChartData = array;
      this.progressIndex['units'] = units;
      this.progressChartLabels = labels;
      this.chart.chart.update();
    });
  }


  homeCategory: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    nav: true,
    navText: ['<i class="ls-angle-left">', '<i class="ls-angle-right">'],
    navSpeed: 700,
    autoHeight: true,
    margin: 15,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 4
      },
      1200: {
        items: 6
      }
    },
  }

  homeCommunity: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    nav: true,
    navText: ['<i class="ls-angle-left">', '<i class="ls-angle-right">'],
    navSpeed: 700,
    autoHeight: false,
    autoWidth: true,
    margin: 15,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      768: {
        items: 4
      },
      992: {
        items: 6
      },
      1200: {
        items: 5
      }
    },
  }

  public progressChartData: ChartDataSets[] = [
    {
      data: [null],
      label: 'How Much',
      lineTension: 0,
      pointBackgroundColor: '#6758F3',
      pointBorderWidth: 2,
      pointRadius: 5,
      pointBorderColor: '#fff',
    },
  ];
  public progressChartLabels: Label[] = this.progressIndex.labels;
  public progressChartColors: Color[] = [
    {
      borderColor: '#6758F3',
      backgroundColor: 'rgba(170,58,243,0.09)',
    },
  ];
  public progressChartLegend = false;
  public progressChartType = 'line';
  public progressChartOptions = {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        fontColor: "#000080",
      }
    },
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          autoSkip: false
        }
      }],
      yAxes: [{
        position: 'right',
        ticks: {
          min: 0,
          max: 100,
          stepSize: 20,
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: (tooltipItems, data) => {
          return this.progressIndex['units'][tooltipItems.datasetIndex][tooltipItems.index];
        }
      }
    }
  }

  public lineChartData: ChartDataSets[] = [
    {
      data: this.timeLogged.data,
      label: 'Time Logged / Cost',
      lineTension: 0,
      pointBackgroundColor: '#6758F3',
      pointBorderWidth: 2,
      pointRadius: 5,
      pointBorderColor: '#fff',
    },
  ];
  public lineChartLabels: Label[] = this.timeLogged.labels;
  public lineChartColors: Color[] = [
    {
      borderColor: '#2D91A3',
      backgroundColor: 'rgba(45, 145, 163, 0.1)',
    },
  ];
  public lineChartLegend = false;
  public lineChartType = 'line';
  public lineChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
        }
      }],

      yAxes: [{
        position: 'right',
        ticks: {
          min: 0,
          max: 1000,
          stepSize: 200,
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: (tooltipItems, data) => {
          let dollar = this.timeOrCost == 'Time' ? '' : '$ ';
          let minute = this.timeOrCost == 'Time' ? ' hr' : '';
          return dollar + tooltipItems.value + minute;
        }
      }
    }
  }
}

